import styled from 'styled-components'
import { Button, Grid, H, P, Wrapper } from '@farewill/ui'
import { BORDER, COLOR, GTR } from '@farewill/ui/tokens'

const StyledPaymentProviderCard = styled(Wrapper)`
  border: 1px solid ${COLOR.GREY.LIGHT};
  border-radius: ${BORDER.RADIUS.S};
  height: 100%;
`

export const PaymentProviderCard = ({
  onPciPalClick,
  isLoading = false,
}: {
  onPciPalClick: () => Promise<void>
  /** Shows the button as loading (and disabled) while the session opens */
  isLoading?: boolean
}) => (
  <Grid>
    <Grid.Item span={12}>
      <StyledPaymentProviderCard padding={GTR.M}>
        <H size="M">Using 8x8</H>
        <P>Take payment using PCI PAL.</P>
        <Button.Primary
          type="button"
          margin={[GTR.S, 0, 0]}
          loading={isLoading}
          onClick={onPciPalClick}
        >
          Pay with PCI PAL
        </Button.Primary>
      </StyledPaymentProviderCard>
    </Grid.Item>
  </Grid>
)

export default PaymentProviderCard
